( () => {
    const sliderSelector = '.ls-testimonials-slider';

    const getRequestedIndex = ( event ) => {
        const control = event.target.closest( '[data-slide-index]' );

        if ( ! control ) {
            return null;
        }

        const index = Number.parseInt( control.dataset.slideIndex, 10 );

        return Number.isInteger( index ) ? index : null;
    };

    const initSlider = ( slider ) => {
        if ( slider.dataset.lsTestimonialsInit === 'true' ) {
            return;
        }

        const slides = Array.from( slider.querySelectorAll( '.ls-testimonials-slider__slide' ) );
        const photos = Array.from( slider.querySelectorAll( '.ls-testimonials-slider__photo-slide' ) );
        const tabs = Array.from( slider.querySelectorAll( '.ls-testimonials-slider__avatar-button' ) );
        const dots = Array.from( slider.querySelectorAll( '.ls-testimonials-slider__dot' ) );

        if ( slides.length < 2 ) {
            slider.dataset.lsTestimonialsInit = 'true';
            return;
        }

        slider.dataset.lsTestimonialsInit = 'true';

        const autoplay = slider.dataset.autoplay === 'true';
        const manualScroll = slider.dataset.manualScroll !== 'false';
        const rawTransitionTime = Number.parseInt( slider.dataset.transitionTime || '5000', 10 );
        const transitionTime = Number.isFinite( rawTransitionTime ) ? Math.max( rawTransitionTime, 1500 ) : 5000;
        let activeIndex = Math.max( 0, slides.findIndex( ( slide ) => slide.classList.contains( 'is-active' ) ) );
        let timer = null;

        const activate = ( nextIndex, focusTab = false ) => {
            const normalizedIndex = ( nextIndex + slides.length ) % slides.length;

            activeIndex = normalizedIndex;

            slides.forEach( ( slide, index ) => {
                const isActive = index === activeIndex;
                slide.classList.toggle( 'is-active', isActive );
                slide.hidden = ! isActive;
            } );

            photos.forEach( ( photo, index ) => {
                const isActive = index === activeIndex;
                photo.classList.toggle( 'is-active', isActive );
                photo.hidden = ! isActive;
            } );

            tabs.forEach( ( tab, index ) => {
                const isActive = index === activeIndex;
                tab.classList.toggle( 'is-active', isActive );
                tab.setAttribute( 'aria-selected', isActive ? 'true' : 'false' );
                tab.setAttribute( 'tabindex', isActive ? '0' : '-1' );
            } );

            dots.forEach( ( dot, index ) => {
                const isActive = index === activeIndex;
                dot.classList.toggle( 'is-active', isActive );
                dot.setAttribute( 'aria-current', isActive ? 'true' : 'false' );
            } );

            if ( focusTab && tabs[ activeIndex ] ) {
                tabs[ activeIndex ].focus();
            }
        };

        const stopAutoplay = () => {
            if ( timer ) {
                window.clearInterval( timer );
                timer = null;
            }
        };

        const startAutoplay = () => {
            if ( ! autoplay ) {
                return;
            }

            stopAutoplay();
            timer = window.setInterval( () => {
                activate( activeIndex + 1 );
            }, transitionTime );
        };

        if ( manualScroll ) {
            slider.addEventListener( 'click', ( event ) => {
                const requestedIndex = getRequestedIndex( event );

                if ( requestedIndex === null ) {
                    return;
                }

                activate( requestedIndex );
                startAutoplay();
            } );

            slider.addEventListener( 'keydown', ( event ) => {
                if ( ! event.target.closest( '.ls-testimonials-slider__avatar-button' ) ) {
                    return;
                }

                if ( event.key === 'ArrowRight' || event.key === 'ArrowDown' ) {
                    event.preventDefault();
                    activate( activeIndex + 1, true );
                    startAutoplay();
                }

                if ( event.key === 'ArrowLeft' || event.key === 'ArrowUp' ) {
                    event.preventDefault();
                    activate( activeIndex - 1, true );
                    startAutoplay();
                }
            } );
        }

        slider.addEventListener( 'mouseenter', stopAutoplay );
        slider.addEventListener( 'mouseleave', startAutoplay );
        slider.addEventListener( 'focusin', stopAutoplay );
        slider.addEventListener( 'focusout', startAutoplay );

        activate( activeIndex );
        startAutoplay();
    };

    const initAll = () => {
        document.querySelectorAll( sliderSelector ).forEach( initSlider );
    };

    if ( document.readyState === 'loading' ) {
        document.addEventListener( 'DOMContentLoaded', initAll );
    } else {
        initAll();
    }
} )();
